<template>
  <div class="fb-richtext" v-if="mode">
    <div class="ckeditor">
      <textarea style="display: none;" :id="id"></textarea>
    </div>
  </div>
  <md-card v-else class="md-elevation-2 md-layout-item">
    <fb-controll
      :controll="saveData.label || 'RichText'"
      @collapse-click="collapsePreview"
      @setting-click="showDialog = true"
      @menu-delete="$emit('menu-delete')"
    />
    <md-content v-show="!collapse">
      <div class="ckeditor">
        <textarea :id="id"></textarea>
      </div>
    </md-content>
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>Settings</md-dialog-title>
      <md-dialog-content>
        <md-field>
          <label>Label</label>
          <md-input v-model="tempData.label"></md-input>
        </md-field>
        <md-field>
          <label>Value</label>
          <md-input v-model="tempData.value"></md-input>
        </md-field>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="cancel">Close</md-button>
        <md-button class="md-primary" @click="save">Save</md-button>
      </md-dialog-actions>
    </md-dialog>
  </md-card>
</template>

<script>
import FbElementMixin from "../FbElementMixin";

export default {
  name: "FbRichText",
  props: ["element", "uuid", "mode", "editor_format"],
  mixins: [FbElementMixin],
  mounted() {
    var inited = false;
    var waitConfigs = setInterval(()=>{
      if (inited) {
        return;
      }
      if (Drupal && Drupal.editors && Drupal.editors.ckeditor5) {
        inited = true;
        setTimeout(() => {
          const ckeditorId = this.id;
          Drupal.editors.ckeditor5.attach(document.getElementById(ckeditorId), window.drupalSettings.editor.formats[this.editorFormat]);
        }, 100);
        const ckeditorId = this.id;
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (mutation.attributeName === 'data-ckeditor5-id') {
              var waitForEditor = setInterval((ckeditor5Id, textArea) => {
                setTimeout(()=>{
                  const editor = Drupal.CKEditor5Instances.get(ckeditor5Id);
                  if (editor) {
                    editor.setData(this.tempData.value);

                    // Save on focus out of the editing document.
                    editor.editing.view.document.on('change:isFocused', (evt, data, isFocused) => {
                      if (!isFocused) {
                        this.tempData.value = editor.getData();
                        this.$emit('input', this.tempData.value);
                      }
                    });

                    clearInterval(waitForEditor);
                    observer.disconnect();
                  }
                }, 100);
              }, 50, mutation.target.dataset.ckeditor5Id, mutation.target);
            }
          });
        });
        observer.observe(document.getElementById(ckeditorId), {attributes: true});
        clearInterval(waitConfigs);
      }
    }, 100);



    if (typeof CKEDITOR != "undefined") {
      const _loadExternalPlugins = function _loadExternalPlugins(format) {
        var externalPlugins = format.editorSettings.drupalExternalPlugins;
        format.editorSettings.drupal = {
          format: format.format
        };
        if (externalPlugins) {
          Object.keys(externalPlugins || {}).forEach(function(pluginName) {
            window.CKEDITOR.plugins.addExternal(
              pluginName,
              externalPlugins[pluginName],
              ""
            );
          });
          delete format.editorSettings.drupalExternalPlugins;
        }
      };
      //config from Back
      if (typeof window.drupalSettings != "undefined") {
        const ckeditorConfig = window.drupalSettings.editor.formats[this.editorFormat].editorSettings;
        _loadExternalPlugins(window.drupalSettings.editor.formats[this.editorFormat]);
        window.CKEDITOR.replace(ckeditorId, ckeditorConfig);
        window.CKEDITOR.instances[ckeditorId].setData(this.tempData.value);
        window.CKEDITOR.instances[ckeditorId].on('change', (data) => {
          this.tempData.value = data.editor.getData();
          this.$emit('input', this.tempData.value);
        });
      }
    }
  },
  destroyed() {
    const ckeditorId = this.id;
    if (Drupal.editors.ckeditor5) {
      Drupal.editors.ckeditor5.detach(document.getElementById(ckeditorId), window.drupalSettings.editor.formats[this.editorFormat]);
      return;
    }
    if (window.CKEDITOR.instances[ckeditorId]) {
      window.CKEDITOR.instances[ckeditorId].destroy();
    }
  },
  computed: {
    id() {
      return "ckeditor" + this.uuid;
    }
  },
  data() {
    return {
      editorFormat: this.editor_format || "full_html",
      tempData: {
        label: this.element.data.label || "",
        value: this.element.data.value || ""
      },
      saveData: {
        label: this.element.data.label || "",
        value: this.element.data.value || ""
      },
    };
  }
};
</script>
